import { DatePipe, SlicePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'cleanDate'
})
export class CleanDatePipe implements PipeTransform {
    //   transform(value: unknown, ...args: unknown[]): unknown {
    //     return null;
    //   }
    transform(value: string | Date, arg?: string): any {
        let val: string = String(value);
        let slicedValue: string;

        if (val.indexOf('/Date(-') >= 0) {
            return '';
        } else if (val.substring(0, 5) === '/Date' || val.substring(0, 5) === '/date') {
            slicedValue = new SlicePipe().transform(val, 6, -2);
            return new Date(parseInt(slicedValue));
        } else if (!moment(val).isValid()) {
            return '';
        } else {
            slicedValue = val;
            return new Date(slicedValue);
        }
    }
}
